import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { TablePage } from "src/shared/components/Table";
import { useGetPartnersDocDeptFilters } from "src/shared/hooks/partnersDocDept/useGetPartnersDocDeptFilters";
import { useGetPartnersDocDeptListQuery } from "../api/api";
import { columns } from "../constants/columns";
import { IPartnersDocDeptRow } from "../types";
import { TableHeader } from "./TableHeader";

export const PartnersDocDept = () => {
  const {
    query,
    filters,
    tableSortModel,
    onPaginationModelChange,
    onFilter,
    onResetFilter,
  } = useGetPartnersDocDeptFilters();

  const { data, isFetching } = useGetPartnersDocDeptListQuery(query);

  const rows: IPartnersDocDeptRow[] =
    data?.data?.map((item) => ({
      partner_id: item.contract.id,
      id: [
        item.contract.id,
        item.document.type.value ?? item.document.type.text,
        item.document.date,
        item.signing.method.value,
        item.document.status.text,
      ].join("-"),

      partner: item.partner.name,
      organization_form: item.partner.organization_form,

      company: item.agency.name,
      contract: item.contract.number,
      document_type: item.document.type.text,
      document_date: item.document.date,
      doc_status: item.document.status.text,
      debt_days: item.debt.days,
      contract_status: item.contract.status.text,
      document_status: item.signing.method.value,
    })) ?? [];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        p: 2,
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Задолженность Партнеров
      </Typography>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "auto",
        }}
      >
        <TablePage
          columns={columns}
          rows={rows}
          loading={isFetching}
          title={<TableHeader />}
          tableFilterModel={{
            onReset: () =>
              onResetFilter([
                "agencies",
                "document_types",
                "contract_statuses",
                "document_statuses",
                "periods",
                "signing_methods",
                "partners",
              ]),
            onFilter,
            filters,
          }}
          sortingMode="server"
          tableSortModel={tableSortModel}
          paginationMode="server"
          rowCount={data?.meta.total}
          paginationModel={{
            page: query.page ? Number(query.page) - 1 : 0,
            pageSize: query.per_page ? Number(query.per_page) : 25,
          }}
          pageSizeOptions={[25, 50, 100]}
          onPaginationModelChange={onPaginationModelChange}
          sx={{
            flex: 1,
            width: "100%",
            "& .MuiDataGrid-root": { flex: 1, width: "100%" },
          }}
        />
      </Box>
    </Box>
  );
};
